import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'

const Terms = styled.div`
  max-width: 60%;
  line-height: 2em;
  margin: 0 auto;
`

export function TermsPage({ data }) {

  return (
    <Layout>
      <SEO title="Terms" />

        <Terms>
            <h2>Algemene Voorwaarden</h2>
        
            {data && data.prismicAboutPage &&
                <div dangerouslySetInnerHTML={{ __html: data.prismicAboutPage.data.terms.html }} />
            }
        </Terms>
    </Layout>
  )
}

export const query = graphql`
    query terms {
        prismicAboutPage {
            data {
                terms {
                    html
                }
            }
        }
    }
`

export default TermsPage
